export function convertTypeToApiType(type: string) {
  //if (type === "exchange") type = "nrq_exchange";
  //if (type === "exchangestep") type = "nrq_exchangestep";
  if (type === "exchange") type = "nrq_exchangestep";
  if (type === "dossier") type = "ae_dossier";
  if (type === "product") type = "ae_product";
  if (type === "lot") type = "ae_lot";
  return type;
}
